import './bootstrap';
import tab from "bootstrap/js/src/tab";

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    beforeSend: function (xhr) {
        xhr.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
    },
    dataType: "json",
    method: "POST",
    async: true,
});


$(document).ready(function() {
    updateTable();
   // runUpdateTimer();
    $('link[rel="preload"]').attr('rel','stylesheet');
});
Swal= Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary btn-product-buy',
            cancelButton: 'btn btn-secondary font-weight-bold',
        },
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
    });


function setInitialLoading(t, isLoading) {
    // overlay се показва само докато initial load не е завършен
    if (isLoading) {
        t.addClass('is-loading-initial');
        t.attr('aria-busy', 'true');
    } else {
        t.removeClass('is-loading-initial');
        t.attr('aria-busy', 'false');
    }
}

let searchDebounceTimeout = null;

$(document)
    .off('input.cclsearch', '.ajax-currencies-table .ccl-search')
    .on('input.cclsearch', '.ajax-currencies-table .ccl-search', function () {
        const t = $(this).closest('.ajax-currencies-table');
        const v = (this.value || '').toString();

        t.data('searchVal', v);

        clearTimeout(searchDebounceTimeout);
        searchDebounceTimeout = setTimeout(() => {
            const q = v.trim();
            const prevSent = ((t.data('lastSentQ') ?? '') + '').trim();

            const shouldSearch = q.length >= 3;
            const shouldReset  = q.length < 3 && prevSent.length >= 3; // връщаме нормалната таблица след като е имало search

            // ВАЖНО: не пускаме update за 1-2 символа (иначе ти мига input-а/blur loop)
            if (shouldSearch || shouldReset || q.length === 0) {
                window.updateTable({ source: 'search' });
            }
        }, 350);
    });

let isUpdatingTable = false;
let hasPendingUpdate = false;

window.updateTable = async function (opts = { source: 'live' }) {

    const hasActiveSearch = (() => {
        const anyFocused = $('.ajax-currencies-table .ccl-search').toArray()
            .some(el => document.activeElement === el);

        const anyRealSearch = $('.ajax-currencies-table').toArray().some(el => {
            const v = ($(el).data('searchVal') ?? '').toString().trim();
            return v.length >= 3;
        });

        return anyFocused || anyRealSearch;
    })();

    if (opts.source === 'live' && hasActiveSearch) {
        return; // не пипаме таблицата докато потребителите търсят за да не създавам  излишни рекуести
    }

    // ако има активна заявка не пускаме нова , а стоят на пендинг
    if (isUpdatingTable) {
        hasPendingUpdate = true;
        return;
    }

    isUpdatingTable = true;
    hasPendingUpdate = false;

    setCartInLoadStatus();

    const tables = $('.ajax-currencies-table');
    if (!tables.length) {
        isUpdatingTable = false;
        updateCart();
        return;
    }

    try {
        await Promise.all(
            tables.map(function () {
                const t = $(this);
                const content = t.find('.ajax-currencies-table__content');

                const initialLoaded = String(t.attr('data-initial-loaded')) === '1';

                const domSearchField = content.find('.ccl-search');
                const domVal = domSearchField.length ? (domSearchField.val() ?? '') : '';
                const storedVal = (t.data('searchVal') ?? domVal).toString();
                const q = storedVal.trim();
                const qForRequest = q.length > 2 ? q : null;

                const sentQ = qForRequest ?? '';

                t.data('lastSentQ', sentQ);

                const isFocused = domSearchField.length && document.activeElement === domSearchField[0];

                if (!initialLoaded) setInitialLoading(t, true);

                return axios.post('/currency/update', {
                    limit: t.attr('data-limit'),
                    column: t.attr('data-column'),
                    type: t.attr('data-type'),
                    position: t.attr('data-position'),
                    q: qForRequest,
                }).then((response) => {

                    // ако потребителят вече е написал нещо различно
                    // от това, което е било изпратено с тази заявка -> НЕ прилагаме този response
                    const latestNow = ((t.data('searchVal') ?? '') + '').trim();
                    const latestForCompare = latestNow.length > 2 ? latestNow : '';
                    if (opts.source === 'search' && latestForCompare !== sentQ) {
                        return; // игнорирараме стария response
                    }

                    content.html(response.data.html);

                    if (!initialLoaded) {
                        t.attr('data-initial-loaded', '1');
                        setInitialLoading(t, false);
                    }

                    // след render: възстановяваме input-а към НАЙ-НОВАТА стойност
                    const updatedSearchField = content.find('.ccl-search');
                    if (updatedSearchField.length) {
                        const latest = (t.data('searchVal') ?? '').toString();
                        updatedSearchField.val(latest);

                        // ако е било фокусирано, връщаме фокус и курсор в края
                        if (isFocused) {
                            updatedSearchField[0]?.focus({ preventScroll: true });
                            const pos = latest.length;
                            updatedSearchField[0].setSelectionRange(pos, pos);
                        }
                    }
                });
            }).get()
        );
    } catch (e) {
        console.log(e);
    } finally {
        isUpdatingTable = false;
        updateCart();

        // ако докато се е обновявало е дошъл нов trigger -> пускаме още 1 update
        if (hasPendingUpdate) {
            hasPendingUpdate = false;
            window.updateTable(opts);
        }
    }
};


function time_remaining(endTime){
    let t =(endTime.getTime() - new Date().getTime()) /1000;
    let seconds = Math.floor(t % 60);
    let minutes = Math.floor((t  / 60) % 60);
    return {'total':t, 'minutes':String(minutes).padStart(2, '0'), 'seconds':String(seconds).padStart(2, '0')};
}

function runClockTimer(timeRemainingContainer,endTime){
    const timeInterval = setInterval(updateClockTimer,1000);
    function updateClockTimer(){
        const timeLeft = time_remaining(endTime);
        timeRemainingContainer.html(timeLeft.minutes+':'+timeLeft.seconds);
        if(timeLeft.total<=0){
            clearInterval(timeInterval);
            setCartInLoadStatus();
            runClockTimer(timeRemainingContainer,getNextUpdateTTL());
        }
    }
    updateClockTimer();
}
function getNextUpdateTTL(){
    let interval=60*$('#updateInterval').val();   // 2min;
    interval*=1000;
    let timeStampStartOfDay = new Date().setHours(0, 0, 0, 0);
    let timeDiff = Date.now() - timeStampStartOfDay;
    let mod = Math.ceil(timeDiff / interval);
    return new Date(timeStampStartOfDay + (mod * interval));
}

const setCartInLoadStatus=window.setCartInLoadStatus=()=> {
    $('.to_amount_show').html('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
}

function runUpdateTimer(){
    let timeRemainingContainer=$('#timeRemainingContainer');
    if(timeRemainingContainer.length===0){
        return;
    }
    runClockTimer(timeRemainingContainer,getNextUpdateTTL());
}

function updateCart(){
    showLoader();
    let cart_table=$('#cart_table');
    let total_table=$('#total_table');
    if(cart_table.length===0 && total_table.length===0){
        return;
    }
    setTimeout(
        ()=>{
            refreshCart();
        },1000
    );

}

function refreshCart() {

    axios.post("/orders/get-items",
            {
                delivery_method: $('.delivery-method:checked').val(),
                payment_method: $('.payment-method:checked').val(),
            })
        .then((response) => {
            $('#cart_table').html(response.data.cart);
            $('#total_table').html(response.data.total);
            $('#payment').html(response.data.htmlPayments);
            $('#freeDelivery').html(response.data.freeDelivertyText);
            $('#labelForUserNotCashBank').html(response.data.labelForUserNotCashBank);
            $('#delivery').html(response.data.htmlDelivery);
            $('#minimumDeviveryText').html(response.data.deliveryShortTextMinimum);
            let deliveryValueOnlyOffice = response.data.deliveryValueOnlyOffice;
            let isCurrencyInOrder = response.data.isCurrencyInOrder;
            let deliveryMinimumBool = response.data.deliveryMinimumBool;

            if (isCurrencyInOrder === 1 ){
                $('.textCartCurrency').css('display', 'block');
            }


            if (deliveryMinimumBool === true ){
                $('.btn-checkout').css('display', 'none');
            }else{
                $('.btn-checkout').css('display', 'inline-flex');
            }
            if (isCurrencyInOrder === 0 ){
                $('.textCartCurrency').css('display', 'none');
            }

            if (deliveryValueOnlyOffice === 1 ){
                $('#deliveryDiv').css('display', 'none');
            }
            if (deliveryValueOnlyOffice === 0 ){
                $('#deliveryDiv').css('display', 'block');
            }

            // ⏳ DOM се обнови – инициализирай JS логиката
            setTimeout(() => {
                bindPaymentDescriptionHandler();
            }, 0);
        })
        .catch((error) => {
            show_error(error.response?.data || 'Грешка при обновяване на количката');
        }).finally(() => {
        hideLoader();
    });


}

function bindPaymentDescriptionHandler() {
    const radios = document.querySelectorAll('.payment-method');
    const radiosDelivery = document.querySelectorAll('.delivery-method');

    const descriptions = {
        econt: document.getElementById('desc-econt'),
        bank: document.getElementById('desc-bank'),
        office: document.getElementById('desc-office')
    };

    const descriptionsDelivery = {
        deliveryEcont: document.getElementById('desc-delivery-econt'),
        deliveryOffice: document.getElementById('desc-delivery-office')
    };

    function updateDescriptions(selected) {
        for (const key in descriptions) {
            if (descriptions[key]) {
                descriptions[key].style.display = (key === selected) ? 'block' : 'none';
            }
        }
    }

    function updateDescriptionsDelivery(selected) {
        for (const key in descriptionsDelivery) {
            if (descriptionsDelivery[key]) {
                descriptionsDelivery[key].style.display = (key === selected) ? 'block' : 'none';
            }
        }
    }

    // 🔁 Плащане
    let hasChecked = false;
    radios.forEach((radio) => {
        if (radio.checked) {
            updateDescriptions(radio.value);
            hasChecked = true;
        }

        radio.addEventListener('change', function () {
            updateDescriptions(this.value);
        });
    });

    if (!hasChecked && radios.length > 0) {
        radios[0].checked = true;
        updateDescriptions(radios[0].value);
    }

    // 🔁 Доставка
    let hasCheckedDelivery = false;
    radiosDelivery.forEach((radio) => {
        if (radio.checked) {
            updateDescriptionsDelivery(radio.value);
            hasCheckedDelivery = true;
        }

        radio.addEventListener('change', function () {
            updateDescriptionsDelivery(this.value);
        });
    });

    if (!hasCheckedDelivery && radiosDelivery.length > 0) {
        radiosDelivery[0].checked = true;
        updateDescriptionsDelivery(radiosDelivery[0].value);
    }
}

const showTopNotification=(message)=>{
    Swal.fire({
        position: 'top-end',
        html: '<div class="fw-bold">'+message+'</div>',
        showConfirmButton: false,
        timer: 700,
        backdrop: false,
        width:'340px',
        background:'var(--bs-primary)',
        padding:'10px',
        color: '#222222',
    });
}
window.addToCart=async function (quantity=0, product_id=0, product_price=0, data={}) {
    try {
        //alert(product_price);
        const response = await axios.post("/orders/add-item", {
            from_currency:  $('#from_currency').val(),
            to_currency:   $('#to_currency').val(),
            from_amount:  $('#from_amount').val(),
            operation:  $('#operation').val(),
            product_id:  product_id,
            quantity:   quantity,
            product_price:   product_price,
        })

        window.newEvent('add_to_cart',response.data);
        $('.cart_count').html(response.data.count);
        showTopNotification(response.data.message);

    } catch (error) {
        show_error(error.response.data);
    }
}

window.addProductToCart=async function (quantity=0, product_id=0, product_price=0, data={}) {

    try {
        const response = await axios.post("/orders/add-item", {
            product_id:  product_id,
            quantity:   quantity,
            product_price:   product_price,
        })

        window.newEvent('add_to_cart',response.data);
       showTopNotification(response.data.message);
        $('.cart_count').html(response.data.count);

    } catch (error) {
        show_error(error.response.data);
    }
}

/*
 * Добавя продукт към черновата на офертите (/offers, таб "Нови оферти").
 * Използва се от бутоните "Изпрати оферта" и "Добави в наблюдавани" -
 * действието е едно и също, само надписите на бутоните се различават.
 */
window.addToOffer = async function (button, productId, quantityFieldId) {
    const btn = button;
    if (!btn || btn.disabled) {
        return;
    }

    const quantity = quantityFieldId
        ? (parseInt(document.getElementById(quantityFieldId)?.value, 10) || 1)
        : 1;

    const originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';

    try {
        const response = await axios.post('/offers/products/' + productId, {quantity: quantity});
        showTopNotification(response.data.message);
        if (typeof response.data.count !== 'undefined') {
            $('.offers_count').html(response.data.count);
        }
    } catch (error) {
        show_error(error.response?.data?.message || 'Продуктът не може да бъде добавен към офертата.');
    } finally {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
    }
}

window.setCartItemAmount=async function (amount, field_type, id) {
    let field = $('#'+field_type+'_' + id);
    let current = parseFloat(field.val()) + amount;
    if (current <= 0) {
        current = 1;
    }
    //alert(current);
    field.val(current.toFixed(2));

    try {
        await axios.post("/orders/update-item", {
            id: id,
            field_type:field_type,
            amount: current,
        })
        updateCart();
    } catch (error) {
        show_error(error.response.data);
    }

}
window.setCartProductItemAmount=async function (amount, field_type, id, product_id) {
    let field = $('#'+field_type+'_' + product_id);
    let current = parseFloat(field.val()) + amount;
    if (current <= 0) {
        current = 1;
    }
    field.val(current.toFixed(2));
    try {
        await axios.post("/orders/update-item", {
            id: id,
            field_type:field_type,
            amount: current,
            product_id: product_id,
        })
        updateCart();
    } catch (error) {
        show_error(error.response.data);
    }

}
window.deleteCartItemAmount=async function (id) {
    try {
        await axios.post("/orders/delete-item", {
            id: id,
        })
        updateCart();
    } catch (error) {
        show_error(error.response.data);
    }
}

window.checkDeliveryMethod=async function () {
            updateCart();
}
window.show_error=function(message){
    Swal.fire(
        {
            title: '',
            html: '<div class="fs-5">' + message + '</div>',
            icon: 'error',
            width:'380px',
        }

    )
}
window.show_success=function(message){
    Swal.fire(
        '',
        message,
        'success'
    )
}
$('body').click(function () {
    /*
     * На страницата /search-results резултатите трябва да останат видими -
     * там #search-container е самата листа с резултати, не изскачащ dropdown.
     * Затварянето там става само през "Изчисти търсенето" или изтриване на
     * думата за търсене (виж resetSearch() / searchBox.on('input', ...)).
     */
    if (!window.location.pathname.includes('search-results')) {
        $('#search-container').addClass('d-none')
    }
});

// 🆕 ДОБАВЕНО: функции за показване/скриване на loader
function showLoader() {
    document.body.classList.add('is-ajax-loading');
    $('#ajaxLoader').css('display','flex');
}
function hideLoader() {
    document.body.classList.remove('is-ajax-loading');
    $('#ajaxLoader').hide();
}


